import { style } from "@vanilla-extract/css";

// cape-core hardcodes the Combobox popover to the trigger's width
// (`.cape_combobox_popover_iDWW4{width:100%}`), which clips options longer
// than our compact trigger (e.g. "Spanish (Latin America)"). `.cape-combobox-list`
// is cape-core's own stable class hook on that popover wrapper — combining it
// with our class here outweighs cape-core's single-class rule regardless of
// stylesheet order. Anchored to the inline-end edge (where the trigger already
// sits, flush against the header's edge) so the widened popover grows toward
// the page center instead of off-screen, in both LTR and RTL.
export const popover = style({
  selectors: {
    "&.cape-combobox-list": {
      width: "max-content",
      minWidth: "100%",
      insetInlineStart: "auto",
      insetInlineEnd: 0,
    },
  },
});
